import api from "app/lib/api";
import endpoints from "static/endpoints";
import { getCurrentUserClinicName } from "utils/currentUser.util";

const formatUploadPayload = (payload) => {
  const fieldsToParse = [
    "physicians",
    "rpmDevices",
    "billingDiagnosisCodes",
    "additionalManufacturer",
    "leadInformation",
    "otherDeviceInformation",
    "batteryInformation",
    "reportNotes",
  ];

  const formData = new FormData();

  for (const key in payload) {
    const value = payload[key];

    const isFieldToParse = fieldsToParse.includes(key);
    const payloadValue = isFieldToParse ? JSON.stringify(value) : value;

    formData.append(key, payloadValue);
  }

  return formData;
};

export const uploadReport = async (payload) => {
  const formData = formatUploadPayload(payload);
  const account = getCurrentUserClinicName();

  const response = await api.post(
    endpoints.manualUpload.uploadReport,
    formData,
    {
      headers: { account },
    }
  );

  return response;
};

export const uploadInOfficeFile = async (payload) => {
  const formData = new FormData();
  const account = getCurrentUserClinicName();

  formData.append("file", payload);
  return await api.post(endpoints.manualUpload.inOfficeUpload, formData, {
    headers: { account },
  });
};

export const findSimilarPatientsFromInOfficeFile = async (payload) => {
  return await api.post(
    endpoints.manualUpload.findSimilarPatientsFromInOfficeFile,
    payload
  );
};

export const extractReportPdfData = async (
  files,
  manufacturer,
  associatedNotes
) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("reports", file));
  formData.append("manufacturer", manufacturer);
  formData.append("associated_note", JSON.stringify(associatedNotes));

  const { data } = await api.post(
    endpoints.manualUpload.extractReportData,
    formData
  );

  return data;
};
